export default "__VITE_ASSET__DP85Z3uV__"